import React from "react";
import { toast } from "react-toastify";
import { CheckCircle } from "lucide-react";

const ToastSuccess = (email: string, successMessage: string[]) => {
  toast(
    () => (
      <div style={{ width: 380 }}>
        <div
          style={{ fontSize: "14px", background: "#F0FDF4" }}
          className="d-flex align-items-center gap-2 px-2 py-1"
        >
          <CheckCircle className="text-success" size={16} />
          <span className="text-success fw-bold">{successMessage[0]}</span>
        </div>
        <div
          style={{
            fontSize: "14px",
            lineHeight: "150%",
            color: "#A1A1A1",
            background: "white",
          }}
          className="px-2 py-2"
        >
          {successMessage[1]}{" "}
          <strong style={{ color: "#232323" }}>{email}</strong>
        </div>
      </div>
    ),
    { autoClose: 3000 ,  hideProgressBar: true,}
  );
};

export default ToastSuccess;
